/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ApplicationAdapter from '../../../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'side_by_side/handover/zendesk_forms';
  },
});
